export const getLinkedFieldIds = (field) =>
  new Set(
    [
      field?.field_id,
      ...(field?.options || []).map((option) => option?.value),
    ].filter(Boolean),
  );

const PREVIEW_ROW_FIELD_TYPES = new Set([
  "text",
  "mobile",
  "email",
  "dollar",
  "money",
  "number",
  "date",
  "todayDate",
  "addressGroup",
  "mobileGroup",
  "multiline",
  "designProAuto",
  "total",
  "checkboxGroup",
  "selectGroup",
]);

export const isPreviewRowField = (field) =>
  PREVIEW_ROW_FIELD_TYPES.has(field?.type) &&
  !(field?.type === "total" && !field?.isEditable);

export const isRightPreviewFormField = (field) =>
  String(field?.field_id ?? "").toLowerCase() !== "pais";

export const findWidgetsForPreviewField = (previewFields = [], field) => {
  const linkedFieldIds = getLinkedFieldIds(field);
  return previewFields.filter((widget) => linkedFieldIds.has(widget?.field_id));
};

export const findWidgetsForClickedWidget = (previewFields = [], widget) => {
  if (!widget?.field_id) return [];
  return previewFields.filter(
    (candidate) => candidate?.field_id === widget.field_id,
  );
};
